export default __webpack_public_path__ + "static/media/job_created_check.f902d61e.svg";